import Vue from 'vue';

const isSupportIntersectionObserver = 'IntersectionObserver' in window;

const intersectionObserver = isSupportIntersectionObserver
  ? new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const imageURL = entry.target.getAttribute('data-lazy-background-image');
        if (!imageURL.length) {
          return;
        }

        // eslint-disable-next-line no-param-reassign
        entry.target.style.backgroundImage = imageURL;
        observer.unobserve(entry.target);
      }
    });
  })
  : null;

Vue.directive('lazy-background-image', {
  // eslint-disable-next-line no-unused-vars
  bind(el, binding, vnode) {
    if (isSupportIntersectionObserver) {
      if (!el.style.backgroundImage) {
        return;
      }
      el.setAttribute('data-lazy-background-image', el.style.backgroundImage);
      // eslint-disable-next-line no-param-reassign
      el.style.backgroundImage = '';
      intersectionObserver.observe(el);
    }
  },
  unbind(el) {
    if (isSupportIntersectionObserver) {
      intersectionObserver.unobserve(el);
    }
  },
});
